import OnSiteSearch from "./OnSiteSearch";

export const onSiteSearch = {
  init: () => {
    const loadMoreButton = document.querySelectorAll(".load__more__results");
    const cardContainer = document.getElementById("result__cards");
    [...loadMoreButton].forEach(() => new OnSiteSearch(cardContainer, loadMoreButton));
  },
};

export default onSiteSearch;
